import {Loader} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import CgoApi from "../api/gen/cgo/CgoApi";
import PasswordResetForm from "../forms/PasswordResetForm";

import './PasswordResetRequestPage.scss'
import {withTranslation, WithTranslation} from "react-i18next";

class PasswordResetRequestPage extends Component<WithTranslation> {

    state = {
        reCaptchaSiteKey: null,
        captchaAllowed: true,
        done: false
    };

    componentDidMount() {
        CgoApi.getReCaptchaSiteKey().then(reCaptchaSiteKey => this.setState({reCaptchaSiteKey}));
    }

    render() {
        const {reCaptchaSiteKey, done} = this.state;
        const {t} = this.props;

        return <div className="password-reset">
            <Container>
                <Row className="password-reset-content">
                    <Col xs={12} sm={6}>
                        {reCaptchaSiteKey && !done && <PasswordResetForm
                            reCaptchaSiteKey={reCaptchaSiteKey}
                            onSubmit={data => CgoApi.requestPasswordReset(data)}
                            onSubmitSuccess={() => this.setState({done: true})}
                        />}
                        {!reCaptchaSiteKey && !done && <Loader />}
                        {done && <Card>
                            <CardHeader>{t('password_change_request')}</CardHeader>
                            <CardBody>
                                {t('password_change_request_accepted_1')}<br/>
                                {t('password_change_request_accepted_2')}
                            </CardBody>
                        </Card>}
                    </Col>
                </Row>
            </Container>
        </div>;
    }
}


export default (withTranslation()(PasswordResetRequestPage));

